module.exports = __webpack_public_path__ + "img/ucloud-logo.84532f2b.png";